export default __webpack_public_path__ + "static/media/mlh-black.ce3d3115.svg";